<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :isAdd="isAdd"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()" @add="addAdmin">
      <div slot="table">
        <admin-table :tableData="tableData.list" @view="view" @update="update" @del="del"></admin-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import adminTable from "./AdminTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getAdminBySearch,newVue,delByAdminId} from "../../network/admin";

  export default {
    name: "AdminList",
    components: {adminTable, MyTable},
    data(){
      return {
        title: "管理员列表",
        //搜索条件
        searchParams:[
          {
            key:"roleName",
            value:"管理员角色"
          },
        ],
        isAdd: true,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/admin/list";
      this.common.HeaderLocationTwo.name = "平台管理员管理";
      this.common.HeaderLocationThree.name = "管理员列表"
      getAdminBySearch().then(res => {
        this.tableData = res.data;
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let roleName = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "roleName"){
            roleName = searchItems[i].input
          }
        }
        getAdminBySearch(roleName,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      view(id){
        this.$router.push("data/"+id)
      },
      update(id){
        this.$router.push("insert/"+id)
      },
      del(id){
        this.$confirm('此操作将永久删除该管理员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByAdminId(id).then(res => {
              this.searchEasy(this.searchItems);
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      addAdmin(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
